import { render, staticRenderFns } from "./ElectricityComponent.vue?vue&type=template&id=147211d6"
import script from "./ElectricityComponent.vue?vue&type=script&lang=js"
export * from "./ElectricityComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports